// src/pages/admin/AdminProductTypes.js
import React, { useEffect, useState } from 'react';
import { Container, Typography, Grid, Paper, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import axiosInstance from '../../services/api';


const AdminProductTypes = () => {
  const [productTypes, setProductTypes] = useState([]);

  useEffect(() => {
    fetchProductTypes();
  }, []);

  const fetchProductTypes = async () => {
    try {
      const response = await axiosInstance.get('/producttypes');
      setProductTypes(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    // Silme işleminden önce kullanıcı onayı soruluyor.
    if (!window.confirm("Bu ürünü silmek istediğinize emin misiniz?")) {
      return;
    }
    try {
      await axiosInstance.delete(`/producttypes/${id}`);
      fetchProductTypes();
    } catch (err) {
      console.error(err);
    }
  };

  return (
  
      <Container>
        <Box sx={{ my: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h4">Ürün Tipleri Yönetimi</Typography>
          <Button variant="contained" color="primary" component={Link} to="/admin/producttypes/new">
            Yeni Ürün Tipi Ekle
          </Button>
        </Box>
        <Grid container spacing={2}>
          {productTypes.map((pt) => (
            <Grid item xs={12} sm={6} md={4} key={pt.id}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="h6">{pt.name}</Typography>
                <Typography variant="body2">{pt.description}</Typography>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
                  <Button variant="outlined" component={Link} to={`/admin/producttypes/edit/${pt.id}`}>
                    Düzenle
                  </Button>
                  <Button variant="outlined" color="error" onClick={() => handleDelete(pt.id)}>
                    Sil
                  </Button>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>

  );
};

export default AdminProductTypes;
